import React from 'react'
import { Query } from 'react-apollo'
import { withLoader } from 'evergreen-draft'
import HAS_PERMISSION_QUERY from './graphql/hasPermissionQuery.graphql'

export enum ResourceType {
  workspace = 'workspace',
  source = 'source'
}

interface IData {
  hasPermission: boolean
}

interface IVariables {
  actions: string[]
  resourceId: string
  resourceType: ResourceType
}

interface IPermissionProps {
  actions?: string[]
  action?: string
  resourceid: string
  resourcetype: ResourceType

  children(props: object): JSX.Element
}

class PermissionQuery extends Query<IData, IVariables> {}

class Permission extends React.Component<IPermissionProps> {
  constructor(props) {
    super(props)
  }

  render() {
    const { action, actions, resourceid, resourcetype } = this.props

    let actionsParam: string[] = []

    if (action) {
      actionsParam = [action]
    }

    if (actions) {
      actionsParam = actions
    }

    return (
      <PermissionQuery
        query={HAS_PERMISSION_QUERY}
        variables={{
          actions: actionsParam,
          resourceId: resourceid,
          resourceType: resourcetype
        }}
      >
        {({ loading, error, data }) => {
          // If loading, return nothing so we don't paint twice
          if (loading) {
            return null
          }

          // If an error or there is no data, assume they don't have access.
          if (error || !data) {
            return this.props.children({ hasPermission: false })
          }

          return this.props.children({ hasPermission: data.hasPermission })
        }}
      </PermissionQuery>
    )
  }
}

export default withLoader(Permission)
